export default "__VITE_ASSET__D4O46uQa__"